import { FeatureFlags } from '~/modules/feature_flags';

export const PARTNER_OF_YEAR_ACHIEVEMENT_FILTER_VALUE = 'partnerOfYear';
// Search contract §1: case-sensitive values; semicolon-separated selections use OR.
// The listing badge key `fdePartner` is a separate contract.
// https://docs.google.com/document/d/1G15sIBT6xsFyfhWMCDfCqWEzA-JeZ_vP5qZGysQ7b00/edit?tab=t.0
export const FDE_ACHIEVEMENT_FILTER_VALUE = 'fde';
export const SUMMIT_ACHIEVEMENT_FILTER_VALUE = 'summit';
export const CONSULTANT_ACHIEVEMENT_VALUES: ReadonlySet<string> = new Set([
    PARTNER_OF_YEAR_ACHIEVEMENT_FILTER_VALUE,
    FDE_ACHIEVEMENT_FILTER_VALUE,
    SUMMIT_ACHIEVEMENT_FILTER_VALUE,
]);

export const CONSULTANT_FILTER_ORDER = ['sfExpertise', 'industryExpertise', 'achievement', 'experts'] as const;

export const isConsultantAchievementFilterEnabled = (type: string): boolean =>
    type === 'consultants' && FeatureFlags.FF_PARTNER_ACHIEVEMENTS_FILTERS;

export const getConsultantDefaultExpand = (): string[] =>
    CONSULTANT_FILTER_ORDER.filter(
        (name) => name !== 'achievement' || isConsultantAchievementFilterEnabled('consultants'),
    );
